/** 管理画面のステップアップ認証（確認コード入力）画面のパス */
export const ADMIN_STEP_UP_VERIFY_PATH = '/admin/verify';
